// Split-screen wrapper for auth pages: a tall emotional image panel on the
// left (desktop only), the form content on the right. The photo's right edge
// is feathered into a warm cream so the two halves blend into one surface
// instead of meeting at a hard seam. On mobile the panel is hidden and the
// form stays clean and centered exactly as before.
const SEAM = '#FBF7F2' // warm cream shared by the form side and the feather

export default function AuthShell({ image = 'auth-embrace', tagline, sub, children }) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: SEAM }}>
      <style>{`
        .auth-art { display: none; }
        @media (min-width: 880px) {
          .auth-art { display: flex; flex: 0 0 46%; max-width: 640px; }
        }
      `}</style>

      {/* Left image panel — desktop only */}
      <div className="auth-art" style={{ position: 'relative', overflow: 'hidden' }}>
        <img
          src={`/brand/${image}.webp`}
          srcSet={`/brand/${image}-700.webp 700w, /brand/${image}.webp 1100w`}
          sizes="46vw"
          alt=""
          aria-hidden="true"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
        />
        {/* warm scrim for tagline legibility (top + bottom) */}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(26,26,26,0.08) 0%, rgba(26,26,26,0) 35%, rgba(26,26,26,0.10) 60%, rgba(26,26,26,0.62) 100%)' }} />
        {/* feather the right edge into the cream form side — kills the hard seam */}
        <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', background: `linear-gradient(90deg, rgba(251,247,242,0) 70%, rgba(251,247,242,0.55) 88%, ${SEAM} 100%)` }} />
        {tagline && (
          <div style={{ position: 'relative', marginTop: 'auto', padding: '2.5rem', zIndex: 1, alignSelf: 'flex-end', width: '100%' }}>
            <p style={{ fontFamily: 'Gibs, serif', fontWeight: 400, fontSize: '1.7rem', lineHeight: 1.3, color: 'white', margin: 0, textShadow: '0 2px 12px rgba(0,0,0,0.45)' }}>{tagline}</p>
            {sub && <p style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.9rem', color: 'rgba(255,255,255,0.9)', margin: '0.6rem 0 0', lineHeight: 1.6, textShadow: '0 1px 8px rgba(0,0,0,0.45)' }}>{sub}</p>}
          </div>
        )}
      </div>

      {/* Right content panel — sits on the same cream, pulled slightly left to
          overlap the feather so the form feels part of the image, not beside it */}
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem 1.25rem', position: 'relative', zIndex: 2 }}>
        {children}
      </div>
    </div>
  )
}
